export const manifest = {
  screens: {
    scr_aumfnw: { name: "Home", route: "/", position: {"x":160,"y":1820} },
    scr_tsyy2z: { name: "Collection — All", route: "/#collection", state: {"filter":"all"}, position: {"x":160,"y":5780} },
    scr_oe1aur: { name: "Collection — Night Suits", route: "/#collection", state: {"filter":"night-suits"}, position: {"x":1560,"y":5780} },
    scr_v87xge: { name: "Collection — T-Shirts", route: "/#collection", state: {"filter":"t-shirts"}, position: {"x":2960,"y":5780} },
    scr_xmk9qt: { name: "Bag", route: "/", state: {"cartOpen":true}, position: {"x":160,"y":11720} },
    scr_9pncxu: { name: "Sign In", route: "/", state: {"accountOpen":true,"accountMode":"signin"}, position: {"x":160,"y":9740} },
    scr_mpi4ch: { name: "Create Account", route: "/", state: {"accountOpen":true,"accountMode":"signup"}, position: {"x":1560,"y":9740} },
  },
  sections: {
    sec_rddybb: { name: "Home", x: 0, y: 1600, width: 1520, height: 1180 },
    sec_b3yw81: { name: "Design Tools", x: 0, y: 3580, width: 2920, height: 1180 },
    sec_h8r1ka: { name: "Collections", x: 0, y: 5560, width: 4320, height: 1180 },
    sec_bseozm: { name: "Atelier", x: 0, y: 7540, width: 1520, height: 1180 },
    sec_usuupb: { name: "Sign In", x: 0, y: 9520, width: 2920, height: 1180 },
    sec_qauqnu: { name: "Shopping Bag", x: 0, y: 11500, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_rddybb", children: [
      { kind: "screen", id: "scr_aumfnw" },
    ] },
    { kind: "section", id: "sec_b3yw81", children: [] },
    { kind: "section", id: "sec_h8r1ka", children: [
      { kind: "screen", id: "scr_tsyy2z" },
      { kind: "screen", id: "scr_oe1aur" },
      { kind: "screen", id: "scr_v87xge" },
    ] },
    { kind: "section", id: "sec_bseozm", children: [] },
    { kind: "section", id: "sec_usuupb", children: [
      { kind: "screen", id: "scr_9pncxu" },
      { kind: "screen", id: "scr_mpi4ch" },
    ] },
    { kind: "section", id: "sec_qauqnu", children: [
      { kind: "screen", id: "scr_xmk9qt" },
    ] },
  ],
}
